import React from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container, Image } from "react-bootstrap";
import { useBluetooth } from "../BluetoothContext";
import logo from "./connectedRemoteLogo.png";
import "bootstrap/dist/css/bootstrap.min.css";

const Header: React.FC = () => {
  const { device } = useBluetooth();

  return (
    <header>
      <Navbar bg="dark" variant="dark" expand="lg" className="py-3">
        <Container>
          {/* Logo */}
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
            <Image
              src={logo}
              alt="Logo"
              width="80"
              height="80"
              className="d-inline-block"
              style={{ objectFit: "contain" }}
            />
          </Navbar.Brand>

          {/* Toggle Button for Mobile View */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          {/* Navigation Links */}
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/">
                Home
              </Nav.Link>
              {device && (
                <>
                  <Nav.Link as={Link} to="/setup">
                    Set Up
                  </Nav.Link>
                  <Nav.Link as={Link} to="/configvol">
                    Configure Volume
                  </Nav.Link>
                  <Nav.Link as={Link} to="/selectchannels">
                    Select Channels
                  </Nav.Link>
                </>
              )}
              <Nav.Link
                href="https://linktr.ee/bmerit_ucalgary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact
              </Nav.Link>
              <Nav.Link
                href="https://bmerit.web.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                About
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
